import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFDownloadLink,
  Font,
  Image,
} from "@react-pdf/renderer";
import React from "react";
// @ts-ignore
import font from "../../../../assest/font/dana-fanum-regular.woff";
import BarandeSaz_Logo from "../../../../assest/images/brand/Avatar.png";
import { IExamAnswerSheetPdfDownloaderProps } from "./ExamAnswerSheetPdfDownloader.models";
import { QuestionOptionTypeString } from "../../../../models/interfaces/exams/questions/QuestionOptions";

Font.register({
  family: "Dana-Fanum",
  format: "truetype",
  src: font,
});
const primaryFontSize = 9;
const styles = StyleSheet.create({
  page: {
    fontSize: primaryFontSize,
    flexDirection: "column",
    textAlign: "right",
    padding: "20px",
    fontFamily: "Dana-Fanum",
  },
  sectionHeader: {
    fontWeight: "bold",
    margin: "5px 0",
    fontSize: primaryFontSize + 3,
    flex: 1,
  },
  rowWarp: {
    display: "flex",
    flexDirection: "row-reverse",
    flexWrap: "wrap",
    textAlign: "right",
  },
  centerAlign: {
    display: "flex",
    justifyContent: "center",
  },
  logo: {
    maxWidth: "80px",
    minWidth: "80px",
  },
  img: {
    maxWidth: "90%",
    minWidth: "90%",
  },
});

const Row = ({ children, style }: any) => (
  <View
    style={[{ display: "flex", flexDirection: "row", width: "100%" }, style]}
  >
    {children}
  </View>
);

const RowItem = ({ title, value }: any) => (
  <>
    <Text style={{ marginLeft: 1 }}> {title} </Text>
    <Text style={{ marginLeft: 10 }}> {value}</Text>
  </>
);

const SectionHeader = ({ children, secondary = false, style = {} }: any) => (
  <Text style={[styles.sectionHeader]}>{children}</Text>
);

const QuestionTitleView = ({ question, style }: any) => (
  <View style={[{ width: "100%", textAlign: "right" }, style]}>
    <Row
      style={{
        ...styles.rowWarp,
        fontWeight: "bold",
      }}
    >
      <Text style={{ marginLeft: 1 }}> {question.index} </Text>
      <Text style={{ marginLeft: 1 }}> - </Text>
      <RowItem
        value={QuestionOptionTypeString(
          question.answers?.filter((answer: any) => answer.isCorrectAnswer)[0]
            .isWhichOption
        )}
        title="پاسخ صحیح گزینه"
      />
    </Row>
    {question.answerSheetAttachmentId != null &&
      question.answerSheetAttachmentId != "" && (
        <Row
          style={{
            ...styles.centerAlign,
            marginBottom: "20px",
          }}
        >
          <Image
            style={{ ...styles.img }}
            src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${question.answerSheetAttachmentId}`}
          />
        </Row>
      )}
    {question.answerSheet != null && question.answerSheet != "" && (
      <Row
        style={{
          ...styles.rowWarp,
          marginBottom: "20px",
          fontWeight: "bold",
          width: "100%",
          marginLeft: 4,
        }}
      >
        <Text> {question.answerSheet} </Text>
      </Row>
    )}
  </View>
);

export default class ExamAnswerSheetPdfDownloader extends React.PureComponent<
  IExamAnswerSheetPdfDownloaderProps,
  { chartImage?: string; performancePercentagechartImage?: string }
> {
  constructor(props: any) {
    super(props);
    this.state = { chartImage: undefined };
  }

  render(): React.ReactNode {
    let { examDetails, questions, coursesWithQuestions } = this.props;

    const ReportDocument = () => (
      <Document>
        <Page size="A4" style={styles.page}>
          <Row
            style={{
              ...styles.centerAlign,
              marginBottom: "20px",
            }}
          >
            <Image style={{ ...styles.logo }} src={BarandeSaz_Logo} />
            <SectionHeader>{examDetails.examTitle}</SectionHeader>
          </Row>
          <Row>
            <SectionHeader>نتیجه آزمون</SectionHeader>
          </Row>
          <Row
            style={{
              ...styles.rowWarp,
              fontWeight: "bold",
            }}
          >
            <RowItem value={examDetails?.totalQuestions} title="تمام سوالات:" />
            <RowItem value={examDetails?.wrongAnswers} title="سوالات غلط:" />
            <RowItem
              value={examDetails?.nonAnswers ?? "-"}
              title="سوالات بدون پاسخ:"
            />
          </Row>
          <Row
            style={{
              ...styles.rowWarp,
              marginTop: "20px",
            }}
          >
            {coursesWithQuestions?.map((coursesWithQuestion) => {
              return (
                <>
                  <Row>
                    <SectionHeader>
                      {coursesWithQuestion.courseTitle}
                    </SectionHeader>
                  </Row>
                  {coursesWithQuestion.questions.map((question, key) => {
                    return <QuestionTitleView key={key} question={question} />;
                  })}
                </>
              );
            })}
          </Row>
        </Page>
      </Document>
    );

    return (
      <>
        {/* <PDFDownloadLink
          document={<ReportDocument />}
          fileName="exam-answer-sheet.pdf"
        >
          {({ blob, url, loading, error }) => (
            <div className="sticky-footer pt-2" id="download-pdf">
              <button className="btn btn-primary tk-full-width">
                دانلود پاسخ برگ (فایل PDF)
              </button>
            </div>
          )}
        </PDFDownloadLink> */}
      </>
    );
  }
}
